<template>
  <el-drawer
    custom-class="client-drawer invoice-drawer"
    v-model="invoiceDrawer.show"
    append-to-body
    @close="closeDrawer"
  >
    <template #title>
      <h4>发票设置</h4>
    </template>

    <template #default>
        <!-- <div class="imgs" v-if="!isEdit"><img src="../../assets/img/确认.png" alt=""></div> -->
      <el-form
        :model="invoiceDrawer.data"
        label-position="top"
        :rules="invoiceDrawer.rules"
        ref="invoiceDrawer"
      >
        <div class="name">
            <div>{{invoiceDrawer.data.billName}}</div>
            <p>税号：{{invoiceDrawer.data.taxpayerCode}}</p>
        </div>

        <el-form-item label="单位地址" prop="billAddress">
          <el-input v-model="invoiceDrawer.data.billAddress" placeholder="请输入单位地址" clearable :disabled="!isEdit"/>
        </el-form-item>

        <el-form-item label="电话号码" prop="billTel">
          <el-input v-model="invoiceDrawer.data.billTel" placeholder="请输入电话号码" clearable :disabled="!isEdit"/>
        </el-form-item>

        <el-form-item label="开户行" prop="billBankName">
          <el-input v-model="invoiceDrawer.data.billBankName" placeholder="请输入开户行名称" clearable :disabled="!isEdit"/>
        </el-form-item>

        <el-form-item label="银行账号" prop="billBankAcct">
          <el-input v-model="invoiceDrawer.data.billBankAcct" placeholder="请输入银行账号" clearable :disabled="!isEdit"/>
        </el-form-item>

        <el-form-item label="收票地址" prop="receiptInvoiceAddress">
          <el-input v-model="invoiceDrawer.data.receiptInvoiceAddress" placeholder="请输入收票地址" clearable :disabled="!isEdit"/>
        </el-form-item>

        <el-row class="merge-input">
          <el-col :span="12">
            <el-form-item label="联系人及手机号" prop="receiptInvoicePerson">
              <el-input v-model="invoiceDrawer.data.receiptInvoicePerson" placeholder="请输入联系人" clearable :disabled="!isEdit"/>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="　" prop="receiptInvoiceTel">
              <el-input v-model="invoiceDrawer.data.receiptInvoiceTel" placeholder="请输入手机号" clearable :disabled="!isEdit"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <el-button
        @click="closeDrawer"
      >取消</el-button>

      <el-button
        type="primary"
        :loading="isloading"
        @click="confirmDrawer"
      >{{ isEdit ? "确定" : "修改" }}</el-button>
    </template>
  </el-drawer>
</template>

<script>
export default {
  name: 'invoice-header', // 发票抬头
  props: {

  },

  data() {
    const phoneVal = (rule, value, callback) => {
        if(!value){
            return callback(new Error('请输入手机号'))
        }else if(!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value)){
            return callback(new Error('请输入11位手机号'))
        }else{
            callback();
        }
    }

    return {
      isloading: false,
      isEdit: false,
      invoiceDrawer: {
        show: false,
        data: {},
        rules: {
          billAddress: [
            { required: true, message: "请输入单位地址", trigger: "blur" }
          ],
          billTel: [
            { required: true, message: "请输入电话号码", trigger: "blur" }
          ],
          billBankName: [
            { required: true, message: "请选择开户银行", trigger: "blur" }
          ],
          billBankAcct: [
            { required: true, message: "请输入银行账号", trigger: "blur" }
          ],
          receiptInvoiceAddress: [
            { required: true, message: "请输入收票地址", trigger: "blur" }
          ],
          receiptInvoicePerson: [
            { required: true, message: "请输入联系人", trigger: "blur" }
          ],
          receiptInvoiceTel: [
            { required: true,  message: "请输入联系电话", trigger: "blur" },
            { validator: phoneVal, trigger: "blur" }
          ]
        }
      }
    }
  },

  computed: {
    
  },

  created() {
    
  },

  methods: {
    init(data) {
      this.invoiceDrawer.data = data
      this.isEdit = !data.isBillConfirm
      this.invoiceDrawer.show = true
    //   this.getClientWorkBench()
    },

    closeDrawer() {
      this.invoiceDrawer.show = false
      this.invoiceDrawer.data = {}
      this.$refs.invoiceDrawer.resetFields()
    },

    confirmDrawer() {
        if (!this.isEdit) {
            this.isEdit = true;
            return;
        }
      this.$refs.invoiceDrawer.validate(valid => {
        if (valid) {
          //发票转电子发票，隐藏逻辑
          // if((this.invoiceDrawer.data.billAddress + '' + this.invoiceDrawer.data.billTel).length > 37) {
          //   this.$message(
          //     {
          //       type: 'error',
          //       message: '因发票打印显示有限，【开票地址】和【电话】总共长度不超过37个字符，可以精简开票地址',
          //       duration: 6000
          //     }
          //   )
          //   return
          // }
          this.isloading = true
          this.$post('/bas/client/basCustomer/saveInvoiceTitle', this.invoiceDrawer.data).then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.$message({
                type: 'success',
                message: data.message,
                offset: 380,
                grouping: true
              })
              this.$emit('confirm')
              this.closeDrawer()
            }
          }).finally(() => {
            this.isloading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.invoice-drawer {
    .el-drawer__header{
        margin-bottom: 0
    }
    .el-drawer__body {
        position: relative;
        padding-top: 40px;
        .name {
            margin-bottom: 20px;
            line-height: 180%;
            div {
                margin-right: 24px;
                font-size: 22px;
                font-weight: bold;
            }
            p {
                font-size: 14px;
                color: #F87243;
            }
        }
        .imgs{
            position: absolute;
            right: 40px;
            top: 10px
        }
    }
}
</style>